import { render, staticRenderFns } from "./CmgNutritionCalculatorPage.vue?vue&type=template&id=15d68d05&scoped=true&lang=pug"
import script from "./cmg-nutrition-calculator-page.ts?vue&type=script&lang=ts&external"
export * from "./cmg-nutrition-calculator-page.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgNutritionCalculatorPage.vue?vue&type=style&index=0&id=15d68d05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d68d05",
  null
  
)

export default component.exports